import { CSS, StyleProps } from "@shared/primitive-components"

export const contentWrap = (): CSS => ({
  flexDirection: `column`,
  width: `100%`,
})

export const listControlsContainer = (props: StyleProps): CSS => ({
  marginBottom: props.theme.spacing(4),
  "@media(max-width: 1240px)": {
    overflowX: `auto`,
    textWrap: `nowrap`,
    "scrollbar-width": `none`,
    "-ms-overflow-style": `none`,
    "&::-webkit-scrollbar": {
      display: `none`,
    },
  },
})

export const title = (hasTooltip: boolean) => () => ({
  fontSize: `1.063rem`,
  flexShrink: 0,
  alignSelf: `center`,
  display: hasTooltip ? `inline-block` : `block`,
})

export const filter = (props: StyleProps) => ({
  marginRight: props.theme.spacing(4),
})

export const marginBottom = (props: StyleProps) => ({
  marginBottom: props.theme.spacing(4),
})

export const searchWrap = (hasLeftButton?: boolean) => ({
  flexShrink: 0,
  marginLeft: hasLeftButton ? `0.8rem` : `0.5rem`,
  width: `250px`,
  "& @media only screen and (max-width: 600px)": {
    marginRight: `0.5rem`,
  },
})

export const apiSearchWrap = (hasLeftButton?: boolean) => ({
  flexShrink: 0,
  marginLeft: hasLeftButton ? `0.8rem` : `0.5rem`,
  width: `350px`,
})

export const text = (hasTabs?: boolean) => (props: StyleProps) => ({
  marginBottom: props.theme.spacing(!hasTabs ? 4 : 8),
})

export const buttonLeft = (props: StyleProps) => ({
  marginLeft: props.theme.spacing(3),
})

export const button = (props: StyleProps) => ({
  marginLeft: props.theme.spacing(3),
})

export const actionWrap = (props: StyleProps): CSS => ({
  marginBottom: props.theme.spacing(4),
})

export const toolTipWrap = (): CSS => ({
  maxWidth: `200px`,
})

export const searchContainer = (): CSS => ({
  position: `relative`,
})

export const searchClearButton = (hasText: boolean): CSS => ({
  position: `absolute`,
  right: `2.375rem`,
  top: `0.391rem`,
  cursor: `pointer`,
  transition: `opacity 0.2s ease-in-out`,
  opacity: hasText ? 1 : 0,
  pointerEvents: !hasText ? `none` : undefined,
})
